export default {
  icon: {
    marginLeft: 5,
    fontSize: 9,
  },
};
